<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <!-- <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增分类</el-button>
          </div> -->
        </zv-table>

        <zv-dialog
          width="400px"
          :title="isEdit ? '修改分类' : '新增分类'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="分类名称：" prop="risk_name">
                <el-input v-model="formData.risk_name" clearable></el-input>
              </el-form-item>
              <el-form-item label="是否开启：" prop="is_open" v-if="isEdit">
                <el-switch
                  v-model="formData.is_open"
                  :inactive-value="0"
                  :active-value="1"
                ></el-switch>
              </el-form-item>
              <el-form-item label="图标:">
                <div v-if="this.formData.picture" style="margin-bottom: 10px;">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="this.formData.picture"
                    fit="fill"
                    :preview-src-list="[this.formData.picture]"
                  >
                  </el-image>
                </div>
                <div>
                  <el-upload
                    :action="uploadUrl"
                    accept="image/*"
                    :show-file-list="false"
                    :data="uploadExtraData"
                    name="file"
                    v-model="formData.picture"
                    :on-success="handleUploadSuccess"
                  >
                    <el-button size="small" type="primary">点击上传图片</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
import tokenService from "@/utils/services/token_service"
import { BaseUrl } from "@/main_config"
export default {
  name: "RiskTypeList",
  mixins: [addFormMixin],
  components: {},
  data() {
    let vm = this;
    return {
      table: {
        api: api.riskTypeList,
        query: {},
        searchData: [
          {
            type: "input",
            model: "risk_name",
            placeholder: "分类名称"
          }
        ],
        columns: [
          {
            title: "分类名称",
            key: "risk_name",
            minWidth: "130",
            showTooltip: true
          },
          {
            title: "图标",
            key: "picture",
            render(h, ctx) {
              let riskImg = '--'
              if (ctx.row.picture) {
                riskImg= h("el-image", {
                  attrs: {
                    src: ctx.row.picture,
                    fit: "fill",
                    "preview-src-list": [ctx.row.picture]
                  },
                  style: "width: 30px; height: 30px"
                });
              }

              return h("span", [riskImg]);
            }
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth: "120",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time, ));
            }
          },
          {
            title: "最后修改时间",
            key: "update_time",
            minWidth: "120",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.update_time));
            }
          },
          {
            title: "开启状态",
            key: "is_open",
            minWidth: "80",
            render(h, ctx) {
              const statusBtn = h("el-switch", {
                attrs: {
                  value: ctx.row.is_open,
                  "inactive-value": 0,
                  "active-value": 1
                  // "inactive-text": "关闭",
                  // "active-text": "开启"
                },
                on: {
                  change(status) {
                    vm.doChangeStatus(status, ctx.row.id);
                  }
                }
              });

              return h("span", [statusBtn]);
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth: "60",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "编辑"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];
              arr.push(editBtn);

              // arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        risk_name: "",
        is_open: true,
        picture: ''
      },
      formRules: {
        risk_name: [
          {
            required: true,
            message: "分类名称不能为空",
            trigger: "blur"
          }
        ]
      },
      adddApi: api.addRiskType,
      editApi: api.editRiskType,
      deleteApi: api.deleteRiskType,
      addSuccessMsg: "添加分类成功",
      editSuccessMsg: "编辑分类成功",
      deleteSuccessMsg: "删除分类成功",
      deleteKey: "id",
      uploadUrl: BaseUrl + '/api.php?do=admin_file_upload',
      uploadExtraData: {
        type: 1,
        dir: 'risk',
        sid: tokenService.getToken()
      }
    };
  },

  computed: {},

  methods: {
    async doChangeStatus(status, id) {
      await this.editApi({
        id,
        is_open: status
      });
      this.$refs.dataTable.refresh();
      this.$message("状态修改成功!");
    },

    handleUploadSuccess(res, file) {
      console.log('ffffffffff')
      console.log(res)
      console.log(file)
      this.formData.picture = res.file
    }
  },

  created() {},

  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped></style>
